import React, { useEffect } from 'react';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const YotpoReviewsSeoWidget = ({ consentCode, errorText, widgetId }) => {
  const isConsentGranted = useConsentCheck(consentCode);
  const isClient = useClient();

  useEffect(() => {
    if (window.yotpoWidgetsContainer?.initWidgets && isConsentGranted) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, [isConsentGranted]);

  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <ErrorCookiesSettings errorText={errorText} />
        </Delay>
      )}
      {isConsentGranted && (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={widgetId}
        ></div>
      )}
    </div>
  );
};

export default YotpoReviewsSeoWidget;
